import React from 'react';
import { ICONIFY } from '../../../../../Constants/iconify';
import OptionsNode from '../../shared/OptionsNode';
import NodeWrapper from '../../shared/NodeWrapper';

function RadioNode({ data }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <OptionsNode data={data} icon={ICONIFY.RADIO} />
        </NodeWrapper>
    );
}

export default React.memo(RadioNode)
